import React from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useStore } from "../../../stores/store";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { useSubmitData } from "../../../hooks/useSubmitData";
import * as yup from "yup";
import { useSetMenu } from "../../../hooks/useSetMenu";
import FormLayout from '../../Generic/FormLayout';
import FormInput from '../../Generic/FormInput';

const Add = () => {

  const { mainStore } = useStore();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();
  useSetMenu(mainStore.TypeOfToolMenuType, mainStore.TypeOfToolMenuNo);
  const onError = (errors, e) =>
    enqueueSnackbar(t("onErrorSubmit"), { variant: "error" });
  const schema = yup.object({
    name: yup
      .string()
      .required(t('requiredField'))
      .max(50, t('maxLength', { max: 50 })),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const sendData = useSubmitData(axiosPrivate, "/TypeOfTools", "/TypeOfTool/List");
  const onSubmit = data => sendData(data);
  const onCancel = () => navigate(-1);

  return (
    <FormLayout title={t("typeOfToolCreateTitle")} onSubmit={handleSubmit(onSubmit, onError)} onCancel={onCancel}>
      <FormInput label="typeOfTool" name="name" register={register} errors={errors} />
    </FormLayout>
  );
};

export default Add;